import $ from 'jquery';

import svg4everybody from './vendor/polyfills/svg4everybody';
import './vendor/polyfills/picturefill';
import './vendor/lazysizes/lazysizes';

import './app/backgroundimage';
import './app/lazysizes';
import './app/map';
import './app/masonry';
import './app/parallax';
import Popup from './app/popup';
import spin from './app/spin';
import swiper from './app/swiper';
import './app/toggle';
import './app/webix/index';
import select from './app/webix/select';
import datePicker from './app/webix/datePicker';
import IMask from 'imask';
import 'easyzoom';

import 'jquery-mask-plugin';

import tippy from 'tippy.js';

svg4everybody();

// Popup
const popup = new Popup('.js-popup', {
    // optional
    activeClassName: 'is-open',
    closeBtn: '.js-popup-close',
    contentBox: '.popup__body',
});

$(document).on('pjax:end', function (event) {
    $(event.target).trigger('init');
});

$(document).on('init', function (event) {
    var target = $(event.target);
    webix.ready(function () {
        select(target);
        datePicker(target);
    });

    target.find('.mask_date').mask('00.00.0000');
    target.find('.mask_time').mask('00:00', {
        placeholder: '__:__'
    });
    target.find('.mask_phone').mask('8 (000) 000-00-00', {
        placeholder: '8 (___) ___-__-__'
    });

    /*target.find('.mask_date').each(function () {
        new IMask(this, {
            mask: '00.00.0000',
            lazy: false,
        })
    })
    target.find('.mask_time').each(function () {
        new IMask(this, {
            mask: '00:00',
            lazy: false,
        })
    })
    target.find('.mask_phone').each(function () {
        new IMask(this, {
            mask: '{8} (000) 000-00-00',
            lazy: false,
        })
    })*/

    swiper(target[0]);
    spin(target[0]);

    target.find('#site-corporate-form').each(function() {
        $.pjax({url: '/site/corporate-form', container: '#site-corporate-form', push: false, timeout: false});
    })

    target.find('.easyzoom').easyZoom();

    target.find('*[data-tippy]').each(function() {
        const el = $(this);
        tippy(el[0], {
            content: el.data('tippy'),
        });
    })
});

$(document).on('submit', 'form', function () {
    let el = $(this);
    el.find('button[type=submit]').each(function () {
        let button = $(this);
        let disabled = button.prop('disabled');
        if (!disabled) {
            button.prop('disabled', true);
            setTimeout(function () {
                button.prop('disabled', false);
            }, 10000);
        }
    });
})
